export class ColdTierBudgetResponse {
    coldTierFeatureBudget;
}
//# sourceMappingURL=cold-tier-budget-response.js.map